var betSlip = {};

betSlip.OnLoaded = {};
betSlip.OnAdd = {};
betSlip.OnSelectionRemoved = {};
betSlip.OnViewUpdated = {};

window.BetSlip = betSlip;

var template = {};
window.TUniSlip = template;


var betSlipUtil = {};

var uniSlip = getUniSlip();

function getUniSlip() {
    uniSlip = uniSlip || (typeof BetSlip !== 'undefined' ? BetSlip : undefined);
    return uniSlip;
}

betSlipUtil.onAdded = function () { return getUniSlip() && uniSlip.OnAdd;}
betSlipUtil.onRemoved = function () { return getUniSlip() && uniSlip.OnSelectionRemoved; }  

betSlipUtil.subscribeOnSelectionRemoved = function (subscriberId, handler) {
    BetSlip.OnSelectionRemoved[subscriberId] = function (selection) {
        handler(selection.BranchID, selection.MasterEventID, selection.EventID, selection.LineID, selection.BetTypeID);
    };
}

betSlipUtil.subscribeOnSelectionAdded = function (subscriberId, handler) {
    BetSlip.OnAdd[subscriberId] = function (sender, selection) {
        handler(selection.BranchID, selection.MasterEventID, selection.EventID, selection.LineID, selection.BetTypeID);
    };
}

window.BetSlipUtil = betSlipUtil;

var modes = {};
window.Modes = modes;